import { PinDropSharp } from "@material-ui/icons";
import { Auth } from "aws-amplify";
import { Howl, Howler } from "howler";
import TagManager from "react-gtm-module";
import { updateConversations } from "../store/action-creators/conversationActionCreator";
import { updateConversationsLoader } from "../store/action-creators/loaderActionCreators";
import fetchConversations, {
  fetchConversationById,
  fetchParticipants,
  fetchUnreadMessagesCountById,
  updateArchiveConversation,
} from "../store/actions/conversationActions";
import { doLogin } from "../store/actions/userActions";
import store from "../store/index";
import {
  ACTIVE,
  ADJUSTER,
  CC_PARAMS_REGEX,
  COPY,
  CUSTOMER,
  DOCUMENT_TITLE,
  NEW,
  RECEIVED,
  REMOVE,
  SESSION_ERROR,
  SNACKBAR,
  TRANSFER,
} from "./constants";
const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const dispatch = store.dispatch;
let timeoutId: any;

let isTabActive: boolean = true;

window.onfocus = function () {
  isTabActive = true;
};

window.onblur = function () {
  isTabActive = false;
};
export const isEmpty = (obj: any) => {
  return (
    !obj ||
    (typeof obj === "string" && obj.length === 0) ||
    (typeof obj === "object" &&
      (Object.keys(obj).length === 0 || obj.length === 0))
  );
};

export const isNotEmpty = (obj: any) => !isEmpty(obj);

export const sortByDate = (array: any[], order: string) => {
  if (order === "desc") {
    return array.sort((a: any, b: any) => {
      return new Date(b.createdTime).valueOf() - new Date(a.createdTime).valueOf();
    })
  }
  else {
    return array.sort((a: any, b: any) => {
      return new Date(a.createdTime).valueOf() - new Date(b.createdTime).valueOf();
    })
  }
}

export const twoStringsAreEqual = (string1: any, string2: any) => {
  return string1?.toUpperCase() === string2?.toUpperCase();
};

export const formatDateTime = (utcDate: string) => {
  let dateObj;
  if (typeof utcDate !== "object") {
    let appendUTC = utcDate + " UTC";
    dateObj = new Date(appendUTC);
  } else {
    dateObj = utcDate;
  }
  let hours = dateObj.getHours();
  let minutes: any = dateObj.getMinutes();
  let day = days[dateObj.getDay()];
  let month = months[dateObj.getMonth()].substr(0, 3);
  let date: any = dateObj.getDate();
  let year:any=dateObj.getFullYear();
  let ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  date = date < 10 ? "0" + date : date;
  return (
    hours + ":" + minutes + " " + ampm + " " + day + ", " + month + " " + date + ", " + year
  );
};

export const getDashboardConversationTime = (utcDate: string) => {
  let appendUTC = utcDate + " UTC";
  let dateObj = new Date(appendUTC);
  let hours = dateObj.getHours();
  let minutes: any = dateObj.getMinutes();
  let month = months[dateObj.getMonth()];
  let date: any = dateObj.getDate();
  let ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  date = date < 10 ? "0" + date : date;
  return (
    month +
    " " +
    date +
    "," +
    dateObj.getFullYear() +
    " - " +
    hours +
    ":" +
    minutes +
    ampm
  );
};

export const getTimeIn12HrsFormat = (time: string) => {
  let hrs = parseInt(time);
  if (hrs >= 12) {
    hrs = hrs % 12;
    return (hrs < 10 ? "0" + hrs : hrs) + time.substr(2) + " PM";
  }
  return time + " AM";
};

export const getCurrentUserInfo = async () => {
  let userInfo = {};
  try {
    userInfo = await Auth.currentUserInfo();
    return userInfo;
  } catch (error) {
    return Response;
  }
};

export const getCurrentSession = () => {
  return Auth.currentSession();
};

export const getSnackbarVariant = (type: any) => {
  switch (type) {
    case SNACKBAR.SUCCESS:
      return "Success";

    case SNACKBAR.ERROR:
      return "Error";

    default:
      return "Error";
  }
};

export const getIsDocumentHidden = () => {
  return !isTabActive;
};

export const soundPlay = (notificationSoundValue: any) => {
  let idSoundPlaying: any;
  let sound = new Howl({
    src: `/media/${notificationSoundValue}.mp3`,
    html5: true,
    loop: false,
    preload: true,
    autoplay: true
  });
  
  sound.once("load", () => {
    idSoundPlaying = sound.play();
  });
  
  sound.once("loaderror", () => {
    Howler.unload();
  });

  sound.once("playerror", () => {
    Howler.unload();
  });
  sound.once("stop", () => { });

  sound.once("unlock", () => { });

  sound.once("end", () => {
    sound.stop(idSoundPlaying);
  });
};

export const handleSubscriptionError = (error: any) => {
  if (error && error.errors && error.errors[0]) {
    let message = error.errors[0].message;
    if (message.includes(SESSION_ERROR)) {
      doLogin();
    }
    console.log(error.message);
  }
};

export const handleLoader = (value: boolean) => {
  dispatch(updateConversationsLoader({ isLoading: value }));
};

export const getUnreadMessagesCount = (unreadMsgs: Object) => {
  let count = 0;
  Object.values(unreadMsgs).forEach((value: number) => {
    count += value;
  });
  return count;
};

export const updateConversationsOrder = (conversationId: any) => {
  const {
    chat: { allConversations }, user
  }: any = store.getState();
  let index = allConversations.findIndex(
    (con: any) => con.conversationId === conversationId
  );
  let updatedConversations: Array<any> = [];
  if (index === -1) {
    fetchConversationById(
      { conversationId: conversationId },
      user?.email,
      (conversation: any) => {
        if (conversation?.pinStatus) {
          updatedConversations = [
            conversation,
            ...allConversations
          ];
        } else {
          const pinnedConversations = getPinnedConversations();
          updatedConversations = [
            ...pinnedConversations,
            conversation,
            ...allConversations?.slice(pinnedConversations.length),
          ];
        }
        dispatch(updateConversations(updatedConversations));
      });
  }
  else {
    if (allConversations[index] && allConversations[index]?.pinStatus) {
      updatedConversations = [
        allConversations[index],
        ...allConversations?.slice(0, index),
        ...allConversations?.slice(index + 1),
      ];
    } else {
      const pinnedConversations = getPinnedConversations();
      updatedConversations = [
        ...pinnedConversations,
        allConversations[index],
        ...allConversations?.slice(pinnedConversations.length, index),
        ...allConversations?.slice(index + 1),
      ];
    }
    dispatch(updateConversations(updatedConversations));
  }
};

// export const updateConversationsOrderCC = (conversation: any) => {
//     const { chat: { allConversations } }: any = store.getState();
//     let updatedConversations: Array<any> = [];
//     if (conversation && conversation?.pinStatus) {
//         updatedConversations = [conversation, ...allConversations];
//     } else {
//         const pinnedConversations = getPinnedConversations();
//         updatedConversations = [...pinnedConversations, conversation, ...allConversations];
//     }
//     dispatch(updateConversations(updatedConversations))
// }

export const updateConversationsOrderCC = (conversation: any) => {
  const {
    chat: { allConversations },
  }: any = store.getState();

  let index = allConversations.findIndex(
    (item: any) => item.conversationId === conversation.conversationId
  );

  let updatedConversations: Array<any> = [];
  if (index !== -1) {
    if (allConversations[index] && allConversations[index]?.pinStatus) {
      updatedConversations = [
        allConversations[index],
        ...allConversations?.slice(0, index),
        ...allConversations?.slice(index + 1),
      ];
    } else {
      const pinnedConversations = getPinnedConversations();
      updatedConversations = [
        ...pinnedConversations,
        allConversations[index],
        ...allConversations?.slice(pinnedConversations.length, index),
        ...allConversations?.slice(index + 1),
      ];
    }
  } else {
    if (conversation && conversation?.pinStatus) {
      updatedConversations = [conversation, ...allConversations];
    } else {
      const pinnedConversations = getPinnedConversations();
      updatedConversations = [
        ...pinnedConversations,
        conversation,
        ...allConversations?.slice(pinnedConversations.length),
      ];
    }
  }

  dispatch(updateConversations(updatedConversations));
};

//Checks and fetch the conversation if that conversation is not in store.
export const checkAndUpdateConversationListFromNewMessage = (
  newMessage: any,
  userId: any
) => {
  const {
    chat: { allConversations },
  }: any = store.getState();
  let isFound = allConversations.find(
    (con: any) => con.conversationId === newMessage.conversationId
  );
  if (!isFound) {
    fetchConversationById(
      { conversationId: newMessage.conversationId },
      userId,
      (conversation: any) => {
        if (checkActiveParticipant(conversation, userId)) {
          const pinnedConversations = getPinnedConversations();
          dispatch(
            updateConversations([
              ...pinnedConversations,
              conversation,
              ...allConversations?.slice(pinnedConversations.length),
            ])
          );
          if (conversation.isArchived === false) {
            dispatch(
              updateArchiveConversation({
                conversationId: conversation.conversationId,
                adjusterId: userId,
                archive: true,
              })
            );
          }
        }
      }
    );
  }
};

export const checkActiveParticipant = (conversation: any, userId: any) => {
  const participant = conversation?.participants?.find((participant: any) =>
    twoStringsAreEqual(participant.adjusterId, userId)
  );
  return participant?.participantStatus === ACTIVE ? true : false;
};

export const isActiveParticipant = (conversationId: any, userId: any) => {
  const {
    user, chat: { allConversations }
  }: any = store.getState();
  const conversation = (allConversations || []).filter(
    (con: any) => con.conversationId === conversationId
  );
  if (conversation.length !== 0) {
    let status = checkActiveParticipant(conversation[0], userId);
    return status;
  }
  else {
   return(status:any)=>{ fetchConversationById(
      { conversationId: conversationId },
      userId,
      (conversation: any) => {
        let status = checkActiveParticipant(conversation[0], userId);
        return status;
      });
    }
  }
};

export const getUpdatedMessages = (newMessage: any) => {
  const {
    chat: { messagesById: messages },
    user,
  }: any = store.getState();
  if (!twoStringsAreEqual(newMessage.from.id, user.email)) {
    return messages[newMessage.conversationId];
  } else {
    return (
      messages[newMessage.conversationId] &&
      // messages[newMessage.conversationId].slice(0, -1)
      messages[newMessage.conversationId].filter((msg: any) => { return !Object.keys(msg).includes("pending") })
    );
  }
};

export const getAllConversationUnreadMsgCount = (conversations: any) => {
  const { user, adjusters }: any = store.getState();
  let adjusterId = isConversationViewer() ? adjusters?.selectedAdjuster?.adjusterEmailId : user.email;
  for (let i = 0; i < conversations?.length; i++) {
    let currentAdjuster =
      conversations[i]?.participants &&
      conversations[i]?.participants.find(
        (p: any) =>
          p.adjusterId === adjusterId &&
          p.participantStatus === ACTIVE &&
          p.participantType === ADJUSTER
      );
    if (currentAdjuster) {
      dispatch(fetchUnreadMessagesCountById(conversations[i].conversationId));
    }
  }
};

export const getConversation = (sound: any, newMsgDetails: any) => {
  const {
    user, chat: { allConversations }
  }: any = store.getState();
  const conversation = (allConversations || []).filter(
    (con: any) => con.conversationId === newMsgDetails?.conversationId
  );
  if (conversation.length !== 0) {
    checkIsActiveAdjuster(conversation[0], newMsgDetails, sound);
  }
  else {
    fetchConversationById(
      { conversationId: newMsgDetails?.conversationId },
      user?.email,
      (res: any) => {
        checkIsActiveAdjuster(res, newMsgDetails, sound);
      });
  }
}

const checkIsActiveAdjuster = (conversation: any, newMsgDetails: any, sound: any) => {
  const {
    user, adjusters: { selectedAdjuster }
  }: any = store.getState();
  let adjusterType: any = {}, currentAdjusterType: any = {}, selectedAdj: any = {};
  if (conversation !== undefined) {
    adjusterType = getAdjDetailsFromConvo(conversation, newMsgDetails.fromId);
    currentAdjusterType = getAdjDetailsFromConvo(conversation, user.email);
    
    if (currentAdjusterType !== undefined && adjusterType !== undefined) {
      // if (isConversationViewer() && selectedAdjuster !==null) {
      //   selectedAdj = getAdjDetailsFromConvo(conversation, selectedAdjuster.adjusterEmailId);
      //   if (selectedAdj !== undefined)
      //     if (adjusterType?.participantType === CUSTOMER
      //       && currentAdjusterType?.participantStatus === ACTIVE && selectedAdj.participantStatus === ACTIVE) {
      //       soundPlay(sound);
      //     }
      // }
     // else {
        if (adjusterType?.participantType === CUSTOMER && currentAdjusterType?.participantStatus === ACTIVE) {
          soundPlay(sound);
        }
     // }
    }
  }
}

const getAdjDetailsFromConvo = (conversation: any, userId: any) => {
  return conversation?.participants &&
    conversation?.participants.find((p: any) => Object.values(p).includes(userId));
}

export const setAlert = (newMsgDetails: any) => {
  const {
    user, chat: { unreadMsgCount }
  }: any = store.getState();

  let sound: any = user?.profileInfo?.adjusterSetting?.notificationSoundValue;
  if (newMsgDetails.type === RECEIVED && sound !=='') {
    getConversation(sound, newMsgDetails);
  }
  if (!isConversationViewer() && getIsDocumentHidden() && newMsgDetails.type === RECEIVED) {
    const oldTitle = DOCUMENT_TITLE;
    let count = getUnreadMessagesCount(unreadMsgCount) + 1;
    let msg = count + " notifications";
    const blink = function () {
      document.title = document.title === msg ? oldTitle : msg;
      if (!getIsDocumentHidden()) {
        clear();
      }
    };
    const clear = function () {
      clearInterval(timeoutId);
      timeoutId = null;
      document.title = DOCUMENT_TITLE;
    };
    if (!timeoutId) {
      timeoutId = setInterval(blink, 1000);
    } else {
      clear();
      timeoutId = setInterval(blink, 1000);
    }
  }
};


//Checks whether all the required params are received from CC or not and if exists checks the data using regex
export const checkAllParamsRequestedFromCC = (params: any) => {
  return (
    isNotEmpty(params) &&
    Object.keys(params).every((param: string) => {
      if(param == "lastName"){// handle empty or balnk lastName
        return true;
      }
      console.log(new RegExp(CC_PARAMS_REGEX[param], "i").test(params[param]));
      return (
        Object.keys(CC_PARAMS_REGEX).includes(param) &&
        new RegExp(CC_PARAMS_REGEX[param], "i").test(params[param])
      );
    })
  );
};

export const formatPhoneNumber = (phoneNumber: string) => {
  const findString = "+1";
  if (phoneNumber !== null) {
    const pos = phoneNumber.includes(findString);
    if (pos) {
      return phoneNumber;
    }
  }
  return "+1" + phoneNumber;
};

export const simpleGTMDataLayer = (dataLayer: Object) => {
  TagManager.dataLayer({ dataLayer });
};

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const formatNewLinesInHtml = (str: any) => {
  return str.replace(/(?:\r\n|\r|\n)/g, "<br>");
};

export const isConversationViewer = () => {
  return window.location.pathname.includes("conversation-viewer");
};

export const getPinnedConversations = () => {
  const {
    chat: { allConversations },
  }: any = store.getState();
  const pinnedConversations = (allConversations || []).filter(
    (con: any) => con.pinStatus
  );
  return pinnedConversations;
};

export const addPinArchiveStatus = (conversation: any, userId: any) => {
  if (conversation) {
    const participant = (conversation?.participants || []).find(
      (p: any) => p.adjusterId === userId
    );
    return {
      ...conversation,
      archiveStatus: participant?.archiveStatus,
      pinStatus: participant?.pinStatus,
      lastMessageTimestamp: new Date(conversation.lastMessageTimestamp),
    };
  } else {
    return conversation;
  }
};

export const getBatchResponseMessage = (batchResponse: any) => {
  const {
    adjusters: { batchType, fromAdjuster, toAdjuster },
  }: any = store.getState();
  switch (batchType) {
    case REMOVE:
      
      return `QuickText has removed you from ${batchResponse?.success
        } conversations ${batchResponse?.failed
          ? `and failed to remove you from ${batchResponse?.failed} conversations. The ${batchResponse?.failed} conversations failed because they don't meet requirements.`
          : ""
        }`;
    case TRANSFER:
      return `QuickText has transferred ${batchResponse?.success
        } conversations ${fromAdjuster?.adjusterName ? `from ${fromAdjuster.adjusterName} ` : ""
        } ${toAdjuster?.adjusterName ? `to ${toAdjuster?.adjusterName}` : ""} ${batchResponse?.failed
          ? `${batchResponse?.failed} conversations did not ${batchType} because they don't meet requirements.`
          : ""
        }`;
    case COPY:
      return `QuickText has copied ${batchResponse?.success} conversations ${fromAdjuster?.adjusterName ? `from ${fromAdjuster.adjusterName} ` : ""
        } ${toAdjuster?.adjusterName ? `to ${toAdjuster?.adjusterName}` : ""} ${batchResponse?.failed
          ? `${batchResponse?.failed} conversations did not ${batchType} because they don't meet requirements.`
          : ""
        }`;
    default:
      break;
  }
};

export const getBatchResponseTitle = () => {
  const {
    adjusters: { batchType },
  }: any = store.getState();
  switch (batchType) {
    case REMOVE:
      return `Remove Process Complete`;
    case TRANSFER:
      return `Transfer Process Complete`;
    case COPY:
      return `Copy Process Complete`;
    default:
      break;
  }
};
